import type { FC } from 'react';

import Level2 from '@crehana/icons/Level2';
import Building from '@crehana/icons/outline/Building';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Avatar, colors } from '@crehana/ui';
import { clsx } from 'clsx';
import { useRouter } from 'next/router';

import type { Response } from '@/views/AdminDashboard/hooks/useSearchOrganizationTeams/types';

const { white, baseMain } = colors;

const ListElement: FC<
  React.PropsWithChildren<{ isDark?: boolean; element: Response }>
> = ({ isDark, element }) => {
  const { push } = useRouter();
  const textColor = isDark
    ? 'tw-text-neutral-light-100'
    : 'tw-text-neutral-light-800';

  return (
    <button
      key={element.id}
      type="button"
      className={`flex items-center px-24 w-full py-12 ${
        isDark ? 'hover:bg-base-lighter-dark-mode' : 'hover:bg-gray-light'
      }`}
      onClick={() => push(element.url)}
    >
      <div className="h-32 min-w-32 mr-20 flex items-center justify-center">
        {element.type === 'user' ? (
          <Avatar src={element.imageUrl} size={32} />
        ) : element.type === 'org' ? (
          <Building size={24} color={isDark ? white : baseMain} />
        ) : (
          <Level2 size={24} color={isDark ? white : baseMain} />
        )}
      </div>
      <div className="text-left">
        <p className={clsx(textColor, 'font-subtitle4')}>{element.title}</p>
        <p
          className={clsx(
            textColor,
            element.type === 'org'
              ? 'font-label text-primary-main'
              : 'font-body4 text-left',
          )}
        >
          {element.subTitle}
        </p>
      </div>
    </button>
  );
};

export default ListElement;
